<template>
  <ModalDefault modal_id="addTagsModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_514')"
                :footer="new_tag.name"
                :method="alertAddTag"
                icon="bx bx-purchase-tag mr-1">
    <div class="px-2 py-2 pb-3" slot="body" style="margin-bottom:30px">
      <div>
        <div class="d-flex">
          <div class="file-upload-center cursor-default w-100" style="align-items: center; align-self: center;">
            <div class="d-block pt-2 px-2">
              <div class="col-12 px-0" :class="fields_with_error.name ? 'text-danger' : ''">
                <label class="mb-0">{{ getTranslations('expression_516') }} </label>
                <div class="input-group" :class="fields_with_error.name ? 'mb-1' : 'mb-4'">
                  <input type="text"
                    :class="fields_with_error.name ? 'border-danger' : ''"
                    v-model="new_tag.name"
                    class="input-modern"
                  >
                </div>
                <span v-if="fields_with_error.name" class="pt-1">{{ fields_with_error.name }}</span>
              </div>
              
              <div class="col-12 px-0" :class="fields_with_error.color ? 'text-danger' : ''">
                <label class="mb-0"> Cor da tag: </label>
                <ColorPicker @change="color => (new_tag.color = color)"
                  v-model="new_tag.color"
                  :with_error="fields_with_error.color"
                  :default-value="new_tag.color" />
                  <span v-if="fields_with_error.color" class="pt-1">{{ fields_with_error.color }}</span>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span @click.prevent="validateFields"
                class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_120') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import ColorPicker from "../kanban/ColorPicker.vue";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalAddTag",
  components: {
    ModalDefault, ColorPicker
  },
  data() {
    return {
      some_field_with_error: false,
      fields_with_error: {
        name: null,
        color: null,
      },
      new_tag: {
        name: "",
        color: ""
      },
    }
  },
  computed: {
    ...mapState(['channels', 'tags']),
    ...mapGetters(['getTranslation'])
  },
  mounted() {
    $('#addTagsModal').on('hidden.bs.modal', () => {
      this.new_tag = {
        name: "",
        color:""
      }
    })
  },
  methods: {
    validateFields() {
      this.some_field_with_error = false;
      this.fields_with_error.name = null;
      this.fields_with_error.color = null;

      if(['',null, undefined].includes(this.new_tag.name)) {
        this.some_field_with_error = true;
        this.fields_with_error.name = this.getTranslations('expression_643');
      }
      if(['',null, undefined].includes(this.new_tag.color)) {
        this.some_field_with_error = true;
        this.fields_with_error.color = this.getTranslations('expression_643');
      }

      if(!this.some_field_with_error) {
        this.alertAddTag();
      }
    },
    alertAddTag() {
      this.new_tag.channel_id = this.channels.channel.id
      this.$store.dispatch("addTag", this.new_tag);
      $('#addTagsModal').modal('hide');
    },
  }
}
</script>

<style scoped>

.input-modern {
  width: 100%; 
  height: 40px; 
  padding: 10px 15px; 
  font-size: 14px; 
  color: #333; 
  background-color: #f9f9f9; 
  border: 2px solid #ddd;
  border-radius: 12px; 
  outline: none; 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
  transition: border-color 0.3s, box-shadow 0.3s; 
}

.input-modern:focus {
  border-color: #222; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15); 
}

.input-modern:hover {
  border-color: #aaa; 
}
</style>
